import { gozokiApiWithAuth } from '../gozokiApi'
import type { RealEstateEventResponse } from '../queries/realEstateEvents.queries'

export const createRealEstateEvent = async (
  data: Partial<RealEstateEventResponse>,
): Promise<RealEstateEventResponse> => {
  const response = await gozokiApiWithAuth.post<RealEstateEventResponse>(
    '/real-estate-events',
    data,
  )
  return response.data
}

export const updateRealEstateEvent = async ({
  id,
  data,
}: {
  id: string
  data: Partial<RealEstateEventResponse>
}): Promise<RealEstateEventResponse> => {
  const response = await gozokiApiWithAuth.patch<RealEstateEventResponse>(
    `/real-estate-events/${id}`,
    data,
  )
  return response.data
}

export const deleteRealEstateEvent = async (id: string): Promise<void> => {
  await gozokiApiWithAuth.delete(`/real-estate-events/${id}`)
}
